import React, { useContext, useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { trainingApi, timesheetApi } from "../../services";
import { AutoComplete } from "primereact/autocomplete";
import { useFormik } from "formik";
import { skillService } from "../../services/profile";
import { toast } from "react-toastify";
import { useLocation } from 'react-router-dom';

export default function Trf({ parent = false, setNewTrf, reload, setScreen, isEdit = false, isView = false, editedTRFData = {} }) {
  const navigate = useNavigate();
  const location = useLocation();
  // const { nominatedEmployeeName, targetSkillData } = location.state || {};
  const [date, setDate] = useState(new Date());
  const [targetSkillData, setTargetSkillData] = useState(null);
  const [nominatedEmployeeName, setNominatedEmployeeName] = useState(null);
  const [enddate, setEndDate] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState();
  const [selectedTechnology, setSelectedTechnology] = useState(null);
  const [filteredSkills, setFilteredSkills] = useState(null);
  const [skillData, setSkillData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [currentstatus, setCurrentstatus] = useState();
  const [loggeduser, setLoggedUser] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentProject, setCurrentProject] = useState();
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [rowClick, setRowClick] = useState(true);
  const [purpose, setPurpose] = useState([]);
  const [business, setBusiness] = useState([]);

  const formik = useFormik({
    initialValues: {
      skills: null,
      gapIdentification: "",
      comments: "",
      hours: null,
    },
    validate: (data) => {
      let errors = {};
      if (!data.skills) {
        errors.skills = "Skill is required.";
      }
      return errors;
    },
    onSubmit: (data) => {
      // save(data);
    },
  });

  useEffect(() => {
    if (isEdit || isView) {
      setDate(new Date(editedTRFData.createdAt))
      setSelectedCategory(editedTRFData?.categoryOfTrainings?.id)
      setCurrentTechnology(editedTRFData.currentTechnology)
      formik.setFieldValue("skills", editedTRFData.targetSkills.title);
      setEndDate(new Date(editedTRFData.endDateOfTraining));
      setSelectedStatus(editedTRFData.status);
      setImprovementArea(editedTRFData.improvementAreaTriggeringTrainingNeed);
      setModuleDetails(editedTRFData.moduleSpecificDetails);
    }
  }, [isEdit || isView]);

  const setCurrentandExpectedSkillSet = (curr_lvl, exp_lvl, productslist) => {
    productslist[0][curr_lvl] = true;
    productslist[1][exp_lvl] = true
    setProducts(productslist);
  }


  const getManagerUserInfo = (param = {}) => {
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        // setEmployeeList(resp?.data?.data);
        if (resp?.data?.data.length > 0) {
          const data = resp?.data?.data;
          // const transformedData = data.map((user) => ({
          //   ...user,
          //   name: `${user.firstName} ${user.lastName}`.trim(),
          //   ecn: user.ecn,
          //   id: user.id,
          // }));
          const transformedData = data.map((user) => {
            return {
              ...user,
              name: `${user.firstName} ${user.lastName}`.trim(),
            }


          });
          setEmployeeList(transformedData);
          if (isEdit || isView) {
            if (editedTRFData?.nameOfNominatedParticipant) {
              var name = editedTRFData.nameOfNominatedParticipant.split(' ')[0];
              const person = transformedData.find(person => person.firstName === name);
              setNominatedEmployeeName(person)
            }

            // if(editedTRFData?.projectName){
            //   const person = transformedData.find(person => person.firstName === name);
            //   if (person.Allocations?.length > 0) {
            //     const firstBillableItem = person.Allocations.find(item => item.isBillable === true);
            //     if (firstBillableItem) {
            //       setSelectedProject(firstBillableItem);
            //       var billable = { id: 1, status: 1, title: "Billable" };
            //       setSelectedStatus(billable)
            //     } else {
            //       setSelectedProject(person.Allocations[0]);
            //       setSelectedStatus();
            //     }
            //     if (!selectedProject) setSelectedStatus()
            //   }
            // }
          }
        }
      } catch (error) {
        // Error handle
      }
    });
  };

  const searchSkill = (event) => {
    setTimeout(() => {
      let _filteredSkills;
      if (!event.query.trim().length) {
        _filteredSkills = [...skillData];
      } else {
        _filteredSkills = skillData.filter((p) => {
          if (p.title !== null) {
            return p.title.toLowerCase().startsWith(event.query.toLowerCase());
          }
        });
      }
      setFilteredSkills(_filteredSkills);
    }, 250);
  };

  const get_skills = () => {
    skillService.getSkills().then((resp) => {
      setSkillData(resp.data.data);
    });
  };

  useEffect(() => {
    const mockProducts = [
      {
        id: 1,
        skills: <b>Current skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
      {
        id: 2,
        skills: <b>Expected skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
    ];
    if (isEdit || isView) {
      const curr_lvl = fetchLevelName(editedTRFData?.currentLevel)
      const exp_lvl = fetchLevelName(editedTRFData?.expectedLevel)
      if (curr_lvl || exp_lvl) {
        setCurrentandExpectedSkillSet(curr_lvl, exp_lvl, mockProducts)
      }
      else setProducts(mockProducts);
    }
    else setProducts(mockProducts);
    get_skills();
    getManagerUserInfo({ pageNum: 0, pageSize: 400 });
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setLoggedUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    fetchEngagement();
    fetchCategories();
    fetchRequestedTraining();
  }, []);

  // useEffect(() => {
  //   formik.setFieldValue("skills", targetSkillData);
  // }, [targetSkillData]);

  const fetchLevelName = (val) => {
    var current_level;
    switch (val) {
      case 1:
        current_level = "beginnerNoKnowledge";
        break;
      case 2:
        current_level = "beginnerBasicKnowledge";
        break;
      case 3:
        current_level = "intermediateGoodKnowledge";
        break;
      case 4:
        current_level = "intermediateStrongExperience";
        break;
      case 5:
        current_level = "expert";
        break;
      default:
        current_level = "";
    }
    return current_level;
  }

  const fetchLevelNumber = (levelName) => {
    const levelMapping = {
      "beginnerNoKnowledge": 1,
      "beginnerBasicKnowledge": 2,
      "intermediateGoodKnowledge": 3,
      "intermediateStrongExperience": 4,
      "expert": 5
    };
    return levelMapping[levelName] || null;
  };

  const fetchEngagement = () => {
    trainingApi.getEngagementTypes().then((resp) => {
      setCurrentstatus(resp.data.data);
    });
  };

  const fetchRequestedTraining = () => {
    trainingApi.getRequestedTraining().then((resp) => {
      const purposedata = resp.data.data.filter(item => item.type === 0);
      const businessdata = resp.data.data.filter(item => item.type === 1);
      setPurpose(purposedata);
      setBusiness(businessdata);
    });
  };

  const fetchCategories = () => {
    trainingApi.fetchTrainingCategoryList().then((resp) => {
      setCategories(resp.data.data);
    });
  };

  const handleCheckboxChangeforPurpose = (e, item) => {
    const updatedData = purpose.map(i =>
      i.id === item.id ? { ...i, isChecked: e.checked } : i
    );
    setPurpose(updatedData);
  };

  const handleCheckboxChangeforBussiness = (e, item) => {
    const updatedData = business.map(i =>
      i.id === item.id ? { ...i, isChecked: e.checked } : i
    );
    setBusiness(updatedData);
  };

  const handleRadioSelection = (productId, skillLevel) => {
    const updatedProducts = products.map((product) => {
      if (product.id === productId) {
        return {
          ...product,
          beginnerNoKnowledge: skillLevel === "beginnerNoKnowledge",
          beginnerBasicKnowledge: skillLevel === "beginnerBasicKnowledge",
          intermediateGoodKnowledge: skillLevel === "intermediateGoodKnowledge",
          intermediateStrongExperience:
            skillLevel === "intermediateStrongExperience",
          expert: skillLevel === "expert",
        };
      }
      return product;
    });
    setProducts(updatedProducts);
  };

  const radioTemplate = (skillLevel) => (rowData) =>
  (
    <RadioButton
      disabled={isView}
      inputId={`${rowData.id}-${skillLevel}`}
      checked={rowData[skillLevel]}
      onChange={() => handleRadioSelection(rowData.id, skillLevel)}
    />
  );

  const [selectedCategories, setSelectedCategories] = useState([
    categories && categories[1] ? categories[1] : "",
  ]);
  const [selectedBusinessCategories, setSelectedBusinessCategories] = useState([
    categories && categories[1] ? categories[1] : "",
  ]);
  const [currentTechnology, setCurrentTechnology] = useState("");
  const [improvementArea, setImprovementArea] = useState("");
  const [moduleDetails, setModuleDetails] = useState("");

  const handleSubmit = () => {
    var dataObj = {
      targetSkill: formik.values.skills?.id,
      categoryOfTraining: isEdit ? selectedCategory?.id : selectedCategory,
      nameOfRequester: loggeduser?.firstName + " " + loggeduser?.lastName,
      ecnOfRequester: loggeduser?.ecn,
      businessUnit: "BU-" + loggeduser?.businessUnitId,
      trainingRequisitionDate: date ? date : new Date().toLocaleDateString(),
      nameOfNominatedParticipant: isEdit ? nominatedEmployeeName : nominatedEmployeeName?.name,
      currentStatusOfNominatedResource: selectedStatus?.status,
      projectName: selectedProject?.Project?.title,
      currentTechnology: currentTechnology,
      improvementAreaTriggeringTrainingNeed: improvementArea,
      moduleSpecificDetails: moduleDetails,
      currentLevel: fetchValue(0),
      expectedLevel: fetchValue(1),
      endDateOfTraining: enddate ? enddate : new Date(new Date().setDate(new Date().getDate() + 7)).toLocaleDateString(),
      purposeOfRequestedTraining: selectedCategories
        .map((category) => category.name)
        .join(", "),
      businessoutcome: selectedBusinessCategories
        .map((category) => category.name)
        .join(", "),
    };
    if (isEdit) {
      dataObj = {
        ...dataObj,
        training: editedTRFData?.id,
      }
      try {
        trainingApi.updateTrainingForm(dataObj).then(
          (resp) => {
            toast.success(resp?.data?.message);
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to update");
      }
    }
    else {
      dataObj = {
        ...dataObj,
        userId: nominatedEmployeeName?.id,
      }
      try {
        trainingApi.createTRFform(dataObj).then(
          (resp) => {
            toast.success(resp.data.message);
            if (resp?.data?.data?.id) {
              setTimeout(() => {
                if (parent) {
                  setNewTrf(false);
                  reload();
                  setScreen('listing');
                } else {
                  navigate(`/trf-approval/${resp.data.data.id}`);
                }
              }, 1000);
            }
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to update");
      }
    }
  };

  const fetchValue = (index) => {
    const getKeyByValue = (obj, value) => {
      return Object.keys(obj).find(key => obj[key] === value);
    };
    const keyWithTrueValue = getKeyByValue(products[index], true);
    return fetchLevelNumber(keyWithTrueValue);
  };

  const nomiatedEmpInfo = (e) => {
    setNominatedEmployeeName(e.target.value);
    setCurrentProject(e.target.value.Allocations);
    if (e.target.value.Allocations?.length > 0) {
      const firstBillableItem = e.target.value.Allocations.find(item => item.isBillable === true);
      if (firstBillableItem) {
        setSelectedProject(firstBillableItem);
        var billable = { id: 1, status: 1, title: "Billable" };
        setSelectedStatus(billable)
      }
      else {
        setSelectedProject(e.target.value.Allocations[0]);
        setSelectedStatus();
      }
      if (!selectedProject) setSelectedStatus()
    }
  }

  return (
    <div className="card full_dialog full_dialog2">
      {!parent && <div className="col">
        <h1 className="p-0 training-heading">TRF Form</h1>
        <hr></hr>
      </div>}
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Name Of Requester (RO)
          </label>
          <InputText
            disabled
            placeholder="Enter Name"
            className="w-full"
            value={loggeduser?.firstName + " " + loggeduser?.lastName}
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="number"
            className="font-bold block mb-2 training-heading mt-2"
          >
            ECN Of Requester
          </label>
          <InputNumber
            disabled
            placeholder="Enter ECN"
            className="w-full"
            value={loggeduser?.ecn}
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Business Unit / Function
          </label>
          <InputText
            disabled
            placeholder="BU"
            className="w-full"
            value={"BU-" + loggeduser?.businessUnitId}
          />
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Training Requisition Date
          </label>
          <Calendar
            disabled={isView}
            value={date}
            onChange={(e) => setDate(e.value)}
            minDate={new Date()}
            placeholder="Select Date"
            showIcon
            className="w-full requisition-date"
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Category Of Training
          </label>
          <Dropdown
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.value)}
            options={categories}
            optionLabel="title"
            optionValue="id"
            placeholder="Select a Category"
            className="w-full"
            disabled={isView}
          />
        </div>
        <div className="col-4">
          <label className="mb-4 mt-2 training-heading">Target Skill</label>
          <div className="mt-2">
            <div className="p-fluid">
              <AutoComplete
                value={formik.values.skills}
                suggestions={filteredSkills}
                completeMethod={searchSkill}
                field="title"
                name="skills"
                // multiple
                virtualScrollerOptions={{ itemSize: 38 }}
                onChange={formik.handleChange}
                placeholder="Enter your area of Expertise/Specialization"
                aria-label="Skills"
                dropdownAriaLabel="Select Skills"
                disabled={isView}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Name Of Nominated Participant
          </label>
          <Dropdown
            value={nominatedEmployeeName}
            onChange={(e) => nomiatedEmpInfo(e)}
            options={employeeList}
            id="nominatedEmployeeName"
            name="nominatedEmployeeName"
            filter
            optionLabel="name"
            // optionValue="name"
            placeholder="Select Employees"
            className="w-full"
            disabled={isView}
          />
          {/* <InputText
            disabled
            value={nominatedEmployeeName}
            placeholder="Name Demo"
            className="w-full"
          /> */}
        </div>
        <div className="col-4">
          <label
            htmlFor="skillset"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Project Details
          </label>
          <Dropdown
            value={selectedProject}
            onChange={(e) => setSelectedProject(e.value)}
            options={currentProject}
            optionLabel="Project.title"
            optionValue="id"
            placeholder="Select Project"
            className="w-full"
            disabled={isView}
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Current Status Of Nominated Resource
          </label>
          <Dropdown
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.value)}
            options={currentstatus}
            optionLabel="title"
            placeholder="Select a Status"
            className="w-full"
            disabled={isView}
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Current Technology
          </label>
          <InputText
            value={currentTechnology}
            placeholder="Enter Current Technology"
            className="w-full"
            style={{ background: "#fff" }}
            onChange={(e) => setCurrentTechnology(e.target.value)}
            disabled={isView}
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 mt-2 training-heading"
          >
            End Date for Training
          </label>
          <Calendar
            value={enddate}
            onChange={(e) => setEndDate(e.value)}
            placeholder="Select Date"
            showIcon
            className="w-full requisition-date"
            disabled={isView}
            minDate={date}
          />
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-6">
          <label
            htmlFor="improvementArea"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Improvement Area Triggering Training Need
          </label>
          <InputTextarea
            id="improvementArea"
            placeholder="Mention specific improvement areas within the required technology..."
            rows={3}
            className="w-full"
            style={{ background: "#fff" }}
            value={improvementArea}
            onChange={(e) => setImprovementArea(e.target.value)}
            disabled={isView}
          />
        </div>
        <div className="col-6">
          <label
            htmlFor="skillset"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Module-Specific Details
          </label>
          <InputTextarea
            id="moduleDetails"
            placeholder="Enter Module Details"
            rows={3}
            className="w-full"
            style={{ background: "#fff" }}
            value={moduleDetails}
            onChange={(e) => setModuleDetails(e.target.value)}
            disabled={isView}
          />
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-12">
          <label
            htmlFor="skillset"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Current & Expected Level Of Skillset
          </label>
          <DataTable
            value={products}
            showGridlines
            selectionMode={rowClick ? null : "radiobutton"}
            selection={selectedProduct}
            onSelectionChange={(e) => setSelectedProduct(e.value)}
            dataKey="id"
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="skills"
              header="Skills"
              style={{ width: "200px" }}
            ></Column>
            <Column
              body={radioTemplate("beginnerNoKnowledge")}
              header="Beginner with no knowledge"
              style={{ width: "200px" }}
            ></Column>
            <Column
              body={radioTemplate("beginnerBasicKnowledge")}
              header="Beginner with basic knowledge"
              style={{ width: "200px" }}
            ></Column>
            <Column
              body={radioTemplate("intermediateGoodKnowledge")}
              header="Intermediate with good knowledge but no hands-on experience"
              style={{ width: "200px" }}
            ></Column>
            <Column
              body={radioTemplate("intermediateStrongExperience")}
              header="Intermediate with strong hands-on experience"
              style={{ width: "200px" }}
            ></Column>
            <Column body={radioTemplate("expert")} header="Expert"></Column>
          </DataTable>
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-12">
          <label
            htmlFor="trainingPurpose"
            className="font-bold block mb-2 mt-2 training-heading table-header"
          >
            Purpose of Requested Training
          </label>
          <div className="card">
            <div className="grid">
              {purpose.map((category) => {
                return (
                  <div key={category.code} className="flex align-items-center col-6">
                    <Checkbox
                      inputId={category.code}
                      name="title"
                      value={category}
                      disabled={isView}
                      checked={category.isChecked === true}
                      onChange={(e) => handleCheckboxChangeforPurpose(e, category)}
                    />
                    <label htmlFor={category.code} className="ml-2">
                      {category.title}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-12">
          <label
            htmlFor="trainingPurpose"
            className="font-bold block mb-2 mt-2 training-heading table-header"
          >
            Which of business outcome (s) mentioned below going to be
            directly/indirectly impacted as an effectiveness of requested
            training ?
          </label>
          <div className="card">
            <div className="grid">
              {business.map((category) => {
                return (
                  <div key={category.code} className="col-6">
                    <Checkbox
                      inputId={category.code}
                      name="title"
                      value={category}
                      disabled={isView}
                      checked={category.isChecked === true}
                      onChange={(e) => handleCheckboxChangeforBussiness(e, category)}
                    />
                    <label htmlFor={category.code} className="ml-2">
                      {category.title}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {!isView &&
        <div className="flex flex-wrap p-field font-bold block mt-4">
          <div className="col-12 flex">
            {
              isEdit ? <Button label="Update" onClick={handleSubmit} /> :
                <Button label="Submit" onClick={handleSubmit} />
            }
            {!parent && <Button label="Back" className="ml-1" severity="secondary" onClick={() => navigate("/training")} />}
          </div>
        </div>
      }
      {/* <pre>{JSON.stringify(selectedCategories,null,4)}</pre> */}
    </div>
  );
}
